import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { TopBarComponent } from './top-bar.component';
import { DialogModule } from '../dialog/dialog.module';
import { SettingsModule } from '../settings/settings.module';

@NgModule({
    declarations: [TopBarComponent],
    providers: [DecimalPipe, CurrencyPipe, DatePipe],
    imports: [
        CommonModule,
        DialogModule,
        SettingsModule
    ],
    exports: [
        TopBarComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TopBarModule {
  customElementComponent: Type<any> = TopBarComponent;

  constructor() {}

  ngDoBootstrap() { }
}
